import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { MultiSelect } from 'primereact/multiselect';
import { Tag } from 'primereact/tag';
import { getInspectionPerformers } from '../../stores/actions/installerActions';

export interface IPerformer {
    id: number;
    name: string;
}

export const performersFromIds = (ids: number[] | null | undefined, options: IPerformer[] | null | undefined, known: IPerformer[] = []): IPerformer[] => {
    const all = [...(Array.isArray(options) ? options : []), ...(known ?? [])];
    return (ids ?? [])
        .map((id) => all.find((p) => p.id === id))
        .filter(Boolean)
        .sort((a, b) => a.name.localeCompare(b.name));
};

// for filtering, sorting and export
export const performersLabel = (performers: IPerformer[] | null | undefined): string | null =>
    performers?.length ? performers.map((p) => p.name).join(', ') : null;

// ids for the form, the API gets the performers as ids
export const performerIdsOf = (serviceAction): number[] =>
    serviceAction.performerIds ?? (serviceAction.performers ?? []).map((p) => p.id);

// one tag per performer, one under another
export const PerformersTags = ({ performers }: { performers: IPerformer[] | null | undefined }) => {
    if (!performers?.length) return null;
    return (
        <div className="flex flex-column align-items-start gap-1">
            {performers.map((p) => <Tag key={p.id} value={p.name} />)}
        </div>
    );
};

interface IServiceActionPerformersFieldProps {
    value: any;
    onChange: (patch: any) => void;
    performerOptions: IPerformer[] | null;
    getInspectionPerformers: () => void;
}

const ServiceActionPerformersField = ({ value, onChange, performerOptions, getInspectionPerformers }: IServiceActionPerformersFieldProps) => {
    useEffect(() => {
        if (!Array.isArray(performerOptions)) {
            getInspectionPerformers();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <MultiSelect value={performerIdsOf(value)}
            onChange={(e) => onChange({ performerIds: e.value, performers: performersFromIds(e.value, performerOptions, value.performers) })}
            options={Array.isArray(performerOptions) ? performerOptions : []} optionLabel="name" optionValue="id"
            display="chip" filter placeholder="Select performers" emptyMessage="No users" />
    );
};

const mapStateToProps = (state) => ({
    performerOptions: state.dashboard.inspectionPerformers,
});

export default connect(mapStateToProps, { getInspectionPerformers })(ServiceActionPerformersField);
